import { render } from "./ChallengeCategory.vue?vue&type=template&id=2ff18747&scoped=true"
import script from "./ChallengeCategory.vue?vue&type=script&lang=js"
export * from "./ChallengeCategory.vue?vue&type=script&lang=js"

import "./ChallengeCategory.vue?vue&type=style&index=0&id=2ff18747&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff18747"]])

export default __exports__